import { useState } from 'react';
import { ChevronDown, ChevronUp, BarChart2 } from 'lucide-react';
import StockComparison from '../components/comparison/StockComparison';
import MarketTrend from '../components/summary/MarketTrend';
import BusinessModel from '../components/summary/BusinessModel';
export function Summary() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isBusinessModelCollapsed, setIsBusinessModelCollapsed] = useState(false);

  return (
    <>
      {/* ============================================
          FEATURE TEMPORARILY DISABLED - Business Model Section
          To re-enable: Uncomment the code block below
          Date disabled: January 23, 2026
          ============================================ */}
      {/* Business Model panel - micro header */}
      {/* <div className="rounded-xl overflow-hidden border border-white/10 bg-white/5 mx-2 mb-2">
        <div className="flex items-center justify-between px-3 py-1.5 bg-white/[0.04] border-b border-white/10">
          <div className="text-[11px] font-semibold text-theme-primary">Business Model</div>
          <button
            type="button"
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-theme-primary/60 hover:text-theme-primary/80"
            aria-expanded={!isExpanded}
          >
            {isExpanded ? <ChevronDown size={14} /> : <ChevronUp size={14} />}
          </button>
        </div>
        <div className={`transition-all duration-300 ease-in-out overflow-hidden ${isExpanded ? 'max-h-0' : 'max-h-96'}`}>
          <div className="p-3">
            <BusinessModel />
          </div>
        </div>
      </div> */}

      {/* Company Performance panel - micro header */}
      <div className="rounded-xl border border-white/10 bg-white/5 mx-2">
        <div className="flex items-center justify-between px-3 py-1.5 bg-white/[0.04] border-b border-white/10">
          <div className="flex items-center gap-2">
            <BarChart2 size={14} className="text-blue-400" />
            <div className="text-[11px] font-semibold text-theme-primary">Company Performance</div>
          </div>
          <button
            type="button"
            onClick={() => setIsBusinessModelCollapsed(!isBusinessModelCollapsed)}
            className="text-theme-primary/60 hover:text-theme-primary/80"
            aria-expanded={!isBusinessModelCollapsed}
          >
            {isBusinessModelCollapsed ? <ChevronDown size={14} /> : <ChevronUp size={14} />}
          </button>
        </div>
        {!isBusinessModelCollapsed && (
          <div className="p-3">
            <MarketTrend />
          </div>
        )}
      </div>

      <StockComparison />

    </>
  );
}